<template>
    <section
        class="TabContent"
    >
        <nav
            class="flex-center"
        >
            <span
                v-for="(tab, index) in tabs"
                :key="index"
                :class="{'is-active' : activeTab === index}"
                class="uppercase"
                @click="switchTab(index)"
            >
                {{ tab }}
            </span>
        </nav>
        <slot :name="tabContentSlot" />
    </section>
</template>
<script>
export default {
    name: 'TabContent',
    props: {
        tabs: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            activeTab: 0,
        };
    },
    computed: {
        tabContentSlot() {
            return `tab-content-${this.activeTab}`;
        },
    },
    methods: {
        switchTab(index) {
            this.activeTab = index;
        },
    },
}
</script>
<style lang="scss" scoped>
    nav {
        border-bottom: 2px solid getColour('sand');
        margin-bottom: getSpacing(spacer);

        span {
            display: block;
            position: relative;
            top: 2px;
            font-size: 12px;
            color: getColour('sand');
            padding-bottom: getSpacing(small);
            margin-right: getSpacing(base);
            border-bottom: 2px solid currentColor;
            cursor: pointer;

            @include media-query(lap-and-up) {
                font-size: 15px;
                padding-bottom: getSpacing(base);
                margin-right: getSpacing(spacer);
            }

            &.is-active {
                color: $action-color;
                //border-color: currentColor;
            }
        }

        @include media-query(lap-and-up) {
            margin-bottom: getSpacing(medium);
        }
    }
</style>
